import { createContext } from 'react';
import type {
  OrganizationContract,
  OrganizationGroupContract,
} from '@raas/shared/src/features/organization/contracts/organization.type';

export interface MyOrganizationDataContextContract {
  myOrganization: OrganizationContract | null;
  setMyOrganization: (organization: OrganizationContract | null) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  myOrganizationGroups: OrganizationGroupContract[];
  setMyOrganizationGroups: (userGroups: OrganizationGroupContract[]) => void;
  isLoadingGroups: boolean;
  setIsLoadingGroups: (isLoading: boolean) => void;
}

const MyOrganizationDataContext = createContext<MyOrganizationDataContextContract | undefined>(
  undefined
);

export default MyOrganizationDataContext;
